import { Component, Signal, inject, ChangeDetectionStrategy } from '@angular/core'
import { StateService } from '../../../services/state.service'
import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonItem,
  IonList,
  IonRadio,
  IonRadioGroup,
  IonTitle,
  IonToolbar,
  RadioGroupCustomEvent,
} from '@ionic/angular'
import { RouterLink } from '@angular/router'
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'app-settings-treatment-place',
  templateUrl: './settings-treatment-place.component.html',
  styles: `
    ion-radio::part(label) {
      display: block;
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    IonButtons,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonBackButton,
    IonContent,
    IonList,
    IonItem,
    IonRadioGroup,
    IonRadio,
    RouterLink,
    TranslateDirective,
    TranslatePipe,
  ],
})
export class SettingsTreatmentPlaceComponent {
  private stateService = inject(StateService)

  readonly currentTreatmentPlace: Signal<string | undefined>

  constructor() {
    this.currentTreatmentPlace = this.stateService.currentTreatmentPlace
  }
  setTreatmentPlace(event: RadioGroupCustomEvent<string>) {
    this.stateService.setCurrentTreatmentPlace(event.detail.value)
  }
}
